import env from '../utils/env';

export const postApiCall = async (url, data) => {
  let responseResult = null;
  try {
    let headers = {
      "Content-Type": "application/json",
    };
    const token = localStorage.getItem("token");
    if (token) {
      // headers["Access-Control-Allow-Origin"] = "https://api.interviewsupport-ai.com/index.php/";
      headers["Authorization"] = `Bearer ${token}`;
    }

    const response = await fetch(env.REACT_APP_API_URL + url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(data),
    });
    responseResult = await response.json();
    handleError(responseResult?.error);
  } catch (error) {
    console.error("Fetch error:", error);
  } finally {
    return responseResult;
  }
};

export const getApiCall = async (url) => {
  let responseResult = null;
  try {
    let headers = {
      "Content-Type": "application/json",
    };
    const token = localStorage.getItem("token");
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }
    const response = await fetch(env.REACT_APP_API_URL + url, {
      method: "GET",
      headers: headers,
    });
    responseResult = await response.json();
    handleError(responseResult?.error);
  } catch (error) {
    console.error("Fetch error:", error);
  } finally {
    return responseResult;
  }
};

export const getPlansApiCall = async () => {
  return await getApiCall("interview-app/plans/list");
};

export const getInterviewDetailApiCall = async () => {
  return await getApiCall("interview-app/interview/detail");
};

export const signupApiCall = async (data) => {
  let responseResult = null;
  try {
    let headers = {
      "Content-Type": "application/json",
    };
    // Note: The backend should be updated to generate a password and send it via email
    const response = await fetch(env.REACT_APP_API_URL + "/interview-app/auth/setup", {
      method: "POST",
      headers: headers,
      body: JSON.stringify(data),
    });
    responseResult = await response.json();
    handleError(responseResult?.error);
  } catch (error) {
    console.error("Fetch error:", error);
  } finally {
    return responseResult;
  }
};

export const loginApiCall = async (data) => {
  let responseResult = null;
  try {
    let headers = {
      "Content-Type": "application/json",
    };
    const response = await fetch(env.REACT_APP_API_URL + "/interview-app/auth/login", {
      method: "POST",
      headers: headers,
      body: JSON.stringify(data),
    });
    responseResult = await response.json();
    handleError(responseResult?.error);
  } catch (error) {
    console.error("Fetch error:", error);
  } finally {
    return responseResult;
  }
};

export const changePasswordApiCall = async (data) => {
  let responseResult = null;
  try {
    let headers = {
      "Content-Type": "application/json",
    };
    const token = localStorage.getItem("token");
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }
    const response = await fetch(env.REACT_APP_API_URL + "/interview-app/users/changepassword", {
      method: "POST",
      headers: headers,
      body: JSON.stringify(data),
    });
    responseResult = await response.json();
    handleError(responseResult?.error);
  } catch (error) {
    console.error("Fetch error:", error);
  } finally {
    return responseResult;
  }
};

export const forgotPasswordApiCall = async (data) => {
  let responseResult = null;
  try {
    let headers = {
      "Content-Type": "application/json",
    };
    const response = await fetch(env.REACT_APP_API_URL + "/interview-app/auth/formatpassword", {
      method: "POST",
      headers: headers,
      body: JSON.stringify(data),
    });
    responseResult = await response.json();
    handleError(responseResult?.error);
  } catch (error) {
    console.error("Fetch error:", error);
  } finally {
    return responseResult;
  }
};

export const logoutApiCall = async () => {
  let responseResult = null;
  try {
    let headers = {
      "Content-Type": "application/json",
    };
    const token = localStorage.getItem("token");
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }
    const response = await fetch(env.REACT_APP_API_URL + "interview-app/users/logout", {
      method: "GET",
      headers: headers,
    });
    responseResult = await response.json();
    handleError(responseResult?.error);
  } catch (error) {
    console.error("Logout error:", error);
  } finally {
    return responseResult;
  }
};

export const deleteApiCall = async (url) => {
  let responseResult = null;
  try {
    let headers = {
      "Content-Type": "application/json",
    };
    const token = localStorage.getItem("token");
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }
    const response = await fetch(env.REACT_APP_API_URL + url, {
      method: "DELETE",
      headers: headers,
    });
    responseResult = await response.json();
    handleError(responseResult?.error);
  } catch (error) {
    console.error("Delete error:", error);
  } finally {
    return responseResult;
  }
};

const handleError = (error) => {
  if (error === "loginUser") {
    localStorage.removeItem("userDetails");
    localStorage.removeItem("token");
    window.location.href = "/";
  }
};
